// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceManagement_root__LzaIA {
  padding: 15px 40px 90px 40px;
  height: 100vh;
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
  color: var(--color-font-10);
  font-size: 16px !important;
}
.InvoiceManagement_title__QySEs {
  display: flex;
  align-items: center;
}
.InvoiceManagement_icon__CANSo {
  padding-right: 10px;
}
.InvoiceManagement_loading_title__N5TXl {
  margin-left: 20px;
}

.InvoiceManagement_arrow_icon__xiCqt {
  padding: 0px 20px;
  color: var(--color-theme-silver);
}

.InvoiceManagement_filter_row__NOmvF {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.InvoiceManagement_date_picker__y\\+IJZ {
  width: 16% !important;
}
::-webkit-calendar-picker-indicator {
  filter: invert(0.2);
}
.InvoiceManagement_text_field__RjQwA {
  width: 18% !important;
}
.InvoiceManagement_select__CDblJ {
  width: 11% !important;
}
.InvoiceManagement_download_button__xai4V {
  width: 18% !important;
  height: 56px !important;
  margin-top: 16px !important;
  margin-bottom: 8px !important;
  border: 1px solid 1;
}
.InvoiceManagement_invoices_list__eQKA9 {
  padding: 0 20px;
  text-align: left;
}

.InvoiceManagement_headers_column__pE334 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.InvoiceManagement_invoice_column__HYM8Z {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
  border: 1px solid lightgray;
  border-radius: 6px;
}

.InvoiceManagement_more_icon__\\+eGlo {
  width: 6% !important;
  cursor: pointer;
}
.InvoiceManagement_more_container__23qYH {
  z-index: 8000;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/InvoiceManagement/InvoiceManagement.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;AACf","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: 100vh;\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n  color: var(--color-font-10);\n  font-size: 16px !important;\n}\n.title {\n  display: flex;\n  align-items: center;\n}\n.icon {\n  padding-right: 10px;\n}\n.loading_title {\n  margin-left: 20px;\n}\n\n.arrow_icon {\n  padding: 0px 20px;\n  color: var(--color-theme-silver);\n}\n\n.filter_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n}\n.date_picker {\n  width: 16% !important;\n}\n::-webkit-calendar-picker-indicator {\n  filter: invert(0.2);\n}\n.text_field {\n  width: 18% !important;\n}\n.select {\n  width: 11% !important;\n}\n.download_button {\n  width: 18% !important;\n  height: 56px !important;\n  margin-top: 16px !important;\n  margin-bottom: 8px !important;\n  border: 1px solid 1;\n}\n.invoices_list {\n  padding: 0 20px;\n  text-align: left;\n}\n\n.headers_column {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.invoice_column {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  justify-content: space-between;\n  border: 1px solid lightgray;\n  border-radius: 6px;\n}\n\n.more_icon {\n  width: 6% !important;\n  cursor: pointer;\n}\n.more_container {\n  z-index: 8000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `InvoiceManagement_root__LzaIA`,
	"title": `InvoiceManagement_title__QySEs`,
	"icon": `InvoiceManagement_icon__CANSo`,
	"loading_title": `InvoiceManagement_loading_title__N5TXl`,
	"arrow_icon": `InvoiceManagement_arrow_icon__xiCqt`,
	"filter_row": `InvoiceManagement_filter_row__NOmvF`,
	"date_picker": `InvoiceManagement_date_picker__y+IJZ`,
	"text_field": `InvoiceManagement_text_field__RjQwA`,
	"select": `InvoiceManagement_select__CDblJ`,
	"download_button": `InvoiceManagement_download_button__xai4V`,
	"invoices_list": `InvoiceManagement_invoices_list__eQKA9`,
	"headers_column": `InvoiceManagement_headers_column__pE334`,
	"invoice_column": `InvoiceManagement_invoice_column__HYM8Z`,
	"more_icon": `InvoiceManagement_more_icon__+eGlo`,
	"more_container": `InvoiceManagement_more_container__23qYH`
};
export default ___CSS_LOADER_EXPORT___;
